<template>
  <li class="profile-nav onhover-dropdown p-0 mr-0">
    <div class="media profile-media">
      <img
        class="b-r-10"
        src="../../assets/images/dashboard/profile.jpg"
        alt=""
      />
      <div class="media-body">
        <span>{{ user.fullname }}</span>
        <p class="mb-0 font-roboto">
          {{ user.roles }} <i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li>
        <a @click="logout"
          ><feather type="log-in"></feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>
  import firebase from 'firebase';
  import UserAuth from '../../auth/js/index';

  export default {
    name: 'Profile',
    data(){
      return {
        user: JSON.parse(localStorage.getItem("user")),
      }
    },
    methods: {
      logout: function() {
        this.$store.dispatch('authentication/logout');
      },
    },
  };
</script>
